import React, { useState, useEffect } from 'react';
import { obtenerMesas, crearMesa, actualizarMesa, eliminarMesa } from '../../services/mesasServicio';
import { obtenerConfiguracionTienda } from '../../services/configTiendaApi';
import config from '../../config/apiConfig';
import { toast } from 'react-toastify';
import QRCode from 'qrcode';

const AdministradorMesas = () => {
    const [mesas, setMesas] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalAbierto, setModalAbierto] = useState(false);
    const [mesaEditando, setMesaEditando] = useState(null);
    const [nombreInput, setNombreInput] = useState("");
    // 🚩 QR
    const [modalQrAbierto, setModalQrAbierto] = useState(false);
    const [mesaQr, setMesaQr] = useState(null);
    const [qrDataUrl, setQrDataUrl] = useState("");
    const [slugTienda, setSlugTienda] = useState("");
    const [cargandoSlug, setCargandoSlug] = useState(false);

    const FRONTEND_URL = window.location.origin; // http://localhost:3000 o dominio real

    useEffect(() => {
        cargarMesas();
        cargarSlug();
    }, []);

    const cargarSlug = async () => {
        const negocioId = localStorage.getItem('negocioId');
        if (!negocioId) return;
        setCargandoSlug(true);
        try {
            const token = localStorage.getItem('token');
            const res = await fetch(`${config.api_url}/api/tienda/configuracion`, {
                headers: { 'token': token }
            });
            const data = await res.json();
            if (data && data.urlSlug) {
                setSlugTienda(data.urlSlug);
            } else if (data && data.url_slug) {
                setSlugTienda(data.url_slug);
            }
        } catch (e) {
            console.error("Error cargando slug:", e);
        } finally {
            setCargandoSlug(false);
        }
    };

    const generarQR = async (mesa) => {
        if (!slugTienda) {
            toast.warning("No se encontró el slug de la tienda. Verifica la configuración.");
            return;
        }
        setMesaQr(mesa);
        const urlQr = `${FRONTEND_URL}/negocio/${slugTienda}?mesa_id=${mesa.id}`;
        try {
            const dataUrl = await QRCode.toDataURL(urlQr, {
                width: 300,
                margin: 2,
                color: { dark: '#000000', light: '#ffffff' }
            });
            setQrDataUrl(dataUrl);
            setModalQrAbierto(true);
        } catch (e) {
            toast.error("Error al generar QR");
        }
    };

    const descargarQR = () => {
        if (!qrDataUrl || !mesaQr) return;
        const link = document.createElement('a');
        link.download = `QR_${slugTienda}_${mesaQr.nombre.replace(/\s+/g, '_')}.png`;
        link.href = qrDataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const cargarMesas = async () => {
        setLoading(true);
        try {
            const data = await obtenerMesas();
            setMesas(Array.isArray(data) ? data : []);
        } catch (error) {
            toast.error("Error al cargar mesas");
        } finally {
            setLoading(false);
        }
    };

    const handleGuardar = async (e) => {
        e.preventDefault();
        if (!nombreInput.trim()) return toast.warning("Escribe un nombre");
        try {
            if (mesaEditando) {
                await actualizarMesa(mesaEditando.id, nombreInput);
                toast.success("Actualizada");
            } else {
                await crearMesa(nombreInput);
                toast.success("Creada");
            }
            setModalAbierto(false);
            setNombreInput("");
            setMesaEditando(null);
            cargarMesas();
        } catch (error) {
            toast.error("Error al guardar");
        }
    };

    const handleEliminar = async (id) => {
        if (!window.confirm("¿Seguro que quieres eliminar esta mesa?")) return;
        try {
            await eliminarMesa(id);
            toast.success("Eliminada");
            cargarMesas();
        } catch (error) {
            toast.error("Error al eliminar");
        }
    };

    const abrirModal = (mesa = null) => {
        setMesaEditando(mesa);
        setNombreInput(mesa ? mesa.nombre : "");
        setModalAbierto(true);
    };

    return (
        <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', color: '#333', fontFamily: '"Segoe UI", sans-serif' }}>
            
            {/* Header Administrativo */}
            <div style={{ borderBottom: '1px solid #f0f0f0', padding: '30px 0', backgroundColor: '#fff' }}>
                <div className="container d-flex justify-content-between align-items-center">
                    <div>
                        <h2 style={{ margin: 0, fontWeight: '800', color: '#111', letterSpacing: '-1px' }}>
                            Configuración de Mesas
                        </h2>
                        <p style={{ margin: 0, color: '#999', fontSize: '14px' }}>Gestiona las ubicaciones y nombres de tu salón</p>
                    </div>
                    <button 
                        className="btn shadow-sm" 
                        style={{ 
                            backgroundColor: '#000', 
                            color: '#fff', 
                            borderRadius: '12px', 
                            padding: '10px 20px',
                            fontWeight: '600',
                            border: 'none'
                        }} 
                        onClick={() => abrirModal(null)}
                    >
                        <i className="fas fa-plus mr-2"></i> Nueva Mesa
                    </button>
                </div>
            </div>

            <div className="container mt-5">
                {loading ? (
                    <div className="text-center mt-5"><div className="spinner-border text-dark"></div></div>
                ) : (
                    <div className="row">
                        {mesas.length === 0 && (
                            <div className="col-12 text-center py-5" style={{ color: '#ccc' }}>
                                <i className="fas fa-couch fa-3x mb-3"></i>
                                <p>No hay mesas configuradas aún.</p>
                            </div>
                        )}
                        
                        {mesas.map((mesa) => (
                            <div key={mesa.id} className="col-md-3 col-6 mb-4">
                                <div style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '16px',
                                    border: '1px solid #eee',
                                    padding: '20px',
                                    textAlign: 'center',
                                    transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 10px rgba(0,0,0,0.02)'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.05)';
                                    e.currentTarget.style.borderColor = '#ddd';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.02)';
                                    e.currentTarget.style.borderColor = '#eee';
                                }}
                                >
                                    <div style={{ color: '#ddd', fontSize: '24px', marginBottom: '10px' }}>
                                        <i className="fas fa-chair"></i>
                                    </div>
                                    <h5 style={{ fontWeight: '700', marginBottom: '5px' }}>{mesa.nombre}</h5>
                                    <div style={{ marginBottom: '15px' }}>
                                        <span style={{ 
                                            fontSize: '10px', 
                                            fontWeight: '800', 
                                            padding: '2px 8px', 
                                            borderRadius: '6px',
                                            backgroundColor: mesa.estado === 'OCUPADA' ? '#fff0f0' : '#f0fff4',
                                            color: mesa.estado === 'OCUPADA' ? '#e53e3e' : '#38a169',
                                            border: mesa.estado === 'OCUPADA' ? '1px solid #feb2b2' : '1px solid #9ae6b4'
                                        }}>
                                            {mesa.estado}
                                        </span>
                                    </div>
                                    
                                    <div className="d-flex justify-content-center" style={{ gap: '8px' }}>
                                        <button 
                                            className="btn btn-sm" 
                                            style={{ backgroundColor: '#f8f9fa', border: '1px solid #eee', borderRadius: '8px', color: '#666' }}
                                            onClick={() => abrirModal(mesa)}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </button>
                                        <button 
                                            className="btn btn-sm" 
                                            style={{ backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9', borderRadius: '8px', color: '#2e7d32' }}
                                            onClick={() => generarQR(mesa)}
                                            title="Generar QR para esta mesa"
                                        >
                                            <i className="fas fa-qrcode"></i>
                                        </button>
                                        <button 
                                            className="btn btn-sm" 
                                            style={{ backgroundColor: '#fff5f5', border: '1px solid #fed7d7', borderRadius: '8px', color: '#e53e3e' }}
                                            onClick={() => handleEliminar(mesa.id)}
                                        >
                                            <i className="fas fa-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* 🚩 MODAL QR */}
            {modalQrAbierto && mesaQr && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)',
                    zIndex: 1060, display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ 
                        backgroundColor: '#fff', 
                        padding: '40px', 
                        borderRadius: '24px', 
                        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', 
                        width: '420px',
                        textAlign: 'center'
                    }}>
                        <h4 style={{ fontWeight: '800', marginBottom: '8px', color: '#111' }}>
                            <i className="fas fa-qrcode" style={{ color: '#2e7d32', marginRight: '8px' }}></i>
                            QR Mesa: {mesaQr.nombre}
                        </h4>
                        <p style={{ color: '#999', fontSize: '13px', marginBottom: '20px' }}>
                            Escanea para pedir desde tu mesa
                        </p>
                        
                        <div style={{ 
                            backgroundColor: '#fff', 
                            padding: '20px', 
                            borderRadius: '16px', 
                            display: 'inline-block',
                            border: '2px dashed #e0e0e0',
                            marginBottom: '20px'
                        }}>
                            <img src={qrDataUrl} alt="QR Mesa" style={{ width: '250px', height: '250px' }} />
                        </div>

                        <p style={{ fontSize: '11px', color: '#aaa', wordBreak: 'break-all', marginBottom: '20px', padding: '0 10px' }}>
                            {FRONTEND_URL}/negocio/{slugTienda}?mesa_id={mesaQr.id}
                        </p>

                        <div className="d-flex flex-column" style={{ gap: '10px' }}>
                            <button 
                                className="btn p-3 fw-bold shadow-sm"
                                style={{ backgroundColor: '#2e7d32', color: '#fff', borderRadius: '12px', border: 'none' }}
                                onClick={descargarQR}
                            >
                                <i className="fas fa-download me-2"></i> DESCARGAR QR
                            </button>
                            <button 
                                className="btn btn-link text-muted" 
                                onClick={() => setModalQrAbierto(false)}
                            >
                                Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL REDISEÑADO (MODERNO) */}
            {modalAbierto && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(5px)',
                    zIndex: 1050, display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                    <div style={{ 
                        backgroundColor: '#fff', 
                        padding: '40px', 
                        borderRadius: '24px', 
                        boxShadow: '0 20px 50px rgba(0,0,0,0.1)', 
                        width: '400px',
                        border: '1px solid #eee'
                    }}>
                        <h4 style={{ fontWeight: '800', marginBottom: '25px', textAlign: 'center' }}>
                            {mesaEditando ? 'Actualizar Mesa' : 'Agregar Nueva Mesa'}
                        </h4>
                        <form onSubmit={handleGuardar}>
                            <div className="form-group mb-4">
                                <label style={{ fontSize: '12px', fontWeight: '700', color: '#999', textTransform: 'uppercase' }}>Nombre de identificación</label>
                                <input 
                                    type="text" 
                                    className="form-control border-0 shadow-sm" 
                                    style={{ 
                                        backgroundColor: '#f8f9fa', 
                                        padding: '12px 15px', 
                                        borderRadius: '12px',
                                        fontSize: '16px'
                                    }}
                                    placeholder="Ej: Mesa VIP 1"
                                    value={nombreInput}
                                    onChange={(e) => setNombreInput(e.target.value)}
                                    autoFocus
                                />
                            </div>
                            <div className="d-flex flex-column" style={{ gap: '10px' }}>
                                <button type="submit" className="btn btn-dark p-3" style={{ borderRadius: '12px', fontWeight: '700' }}>
                                    Confirmar y Guardar
                                </button>
                                <button type="button" className="btn btn-link text-muted" onClick={() => setModalAbierto(false)}>
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdministradorMesas;